import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppointmentService, Appointment } from '../Services/appointment.service'

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  appointments: Appointment[] = [];
  newAppointment: Appointment = {
    id: 0,
    title: '',
    startTime: new Date(),
    endTime: new Date(),
    location: '',
    description: '',
    userGuid: '',
    projectId: 0
  };
  editingAppointment: Appointment | null = null;
  projectId: number = 0;

  constructor(
    private appointmentService: AppointmentService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.projectId = +id; // Convert string to number
        this.newAppointment.projectId = this.projectId; // Set projectId for new appointments
        this.loadAppointments();
      }
    });
  }

  loadAppointments(): void {
    this.appointmentService.getAppointments(this.projectId).subscribe({
      next: (appointments) => this.appointments = appointments,
      error: (err) => console.error('Failed to load appointments', err)
    });
  }

  addAppointment(form: NgForm): void {
    if (form.valid && this.newAppointment.title && this.newAppointment.userGuid) {
      this.newAppointment.projectId = this.projectId; // Ensure projectId is set
      this.appointmentService.createAppointment(this.newAppointment).subscribe({
        next: (appointment) => {
          this.appointments.push(appointment);
          this.resetForm();
          form.resetForm();
        },
        error: (err) => console.error('Failed to create appointment', err)
      });
    }
  }

  editAppointment(appointment: Appointment): void {
    this.editingAppointment = { ...appointment };
    this.newAppointment = { ...appointment };
  }

  updateAppointment(form: NgForm): void {
    if (this.editingAppointment && form.valid && this.newAppointment.title && this.newAppointment.userGuid) {
      this.newAppointment.projectId = this.projectId; // Ensure projectId is set
      this.appointmentService.updateAppointment(this.editingAppointment.id, this.newAppointment).subscribe({
        next: () => {
          const index = this.appointments.findIndex(app => app.id === this.editingAppointment!.id);
          if (index !== -1) {
            this.appointments[index] = { ...this.newAppointment, id: this.editingAppointment!.id };
            this.resetForm();
            form.resetForm();
          }
        },
        error: (err) => console.error('Failed to update appointment', err)
      });
    }
  }

  deleteAppointment(id: number): void {
    this.appointmentService.deleteAppointment(id).subscribe({
      next: () => {
        this.appointments = this.appointments.filter(app => app.id !== id);
      },
      error: (err) => console.error('Failed to delete appointment', err)
    });
  }

  resetForm(): void {
    this.newAppointment = {
      id: 0,
      title: '',
      startTime: new Date(),
      endTime: new Date(),
      location: '',
      description: '',
      userGuid: '',
      projectId: this.projectId
    };
    this.editingAppointment = null;
  }
}